import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useTheme } from '@bcp-nextgen-dx-component-factory/design-system';

export interface ContactYouSoonHelperOutput {
	cerise: string;
	resources: ContactYouSoonHelperResources;
}

export interface ContactYouSoonHelperResources {
	title: string;
	description: string;
}

export const useContactYouSoonHelper = (): ContactYouSoonHelperOutput => {
	const t = useTranslation();
	const theme = useTheme();

	const cerise = theme.colorPalette.color_02[100];

	const resources: ContactYouSoonHelperResources = {
		title: t('placeholder.conclusion.instructions.title'),
		description: t('placeholder.conclusion.instructions.description'),
	};

	return { cerise, resources };
};
